import { initializeApp, type FirebaseOptions } from 'firebase/app';
import { browserLocalPersistence, getAuth, onIdTokenChanged, setPersistence, signInWithEmailAndPassword, signOut, type Auth, type User } from 'firebase/auth';

let auth: Auth | null = null;
let persistenceReady: Promise<void> | null = null;

export function initializeConsoleFirebase(options: FirebaseOptions): Auth {
  auth ??= getAuth(initializeApp(options, 'autonomous-team-console'));
  persistenceReady ??= setPersistence(auth, browserLocalPersistence);
  return auth;
}

export function observeConsoleUser(listener: (user: User | null) => void): () => void {
  if (auth === null) throw new Error('Firebase is not initialized');
  return onIdTokenChanged(auth, listener);
}

export async function consoleIdToken(forceRefresh = false): Promise<string | null> {
  return auth?.currentUser?.getIdToken(forceRefresh) ?? null;
}

export async function signInConsole(email: string, password: string): Promise<void> {
  if (auth === null) throw new Error('Firebase is not initialized');
  await persistenceReady;
  await signInWithEmailAndPassword(auth, email, password);
}

export async function signOutConsole(): Promise<void> {
  if (auth !== null) await signOut(auth);
}
